import Core from "@/modules/core/service/Core";

const url = {
    process   : "/api/incident/customer/{0}/docexport",
    download  : "/api/incident/customer/docexport/{0}",
    folderInfo: "/api/elo/folder/{0}?category=06 Wartungsbelege",
    assign    : "/api/incident/docexport/unit/{0}?source={1}&target={2}&step={3}&type=MAINTENANCE",
}

export default {
    validate (customerId, typeId, from, to) {
        return Core.method.put(url.process, {
            typename: typeId,
            from    : from,
            to      : to,
            filename: "xxx.zip"
        }, customerId);
    },

    folderinfo (unitId) {
        return Core.method.get(url.folderInfo, unitId);
    },

    process (customerId, document) {
        return Core.method.post(url.process, document, customerId);
    },

    assign (unit, steDataId, document, target) {
        return Core.method.put(url.assign, null, unit, document.guid, target.id, steDataId);
    },

    download (txId, success, error) {
        Core.transfer.load(url.download.replace("{0}", txId), success, error);
    }
}